import { default as _91_46_46_46filtersQuery_93LXCQnWF6hfMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/[...slug]/[lastSlug]-c-[id]/[...filtersQuery].vue?macro=true";
import { default as _404uJk0h2LGVpMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/404.vue?macro=true";
import { default as indexZfXNOgM6FtMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/abonnement-livraison/index.vue?macro=true";
import { default as indexxuoAe3T0EiMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/accueil-fidelite/index.vue?macro=true";
import { default as _91ean_93KcrUJDUM4SMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article-ean/[ean].vue?macro=true";
import { default as _91_91slug_93_93yEodQVTP24Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article/[id]/[[slug]].vue?macro=true";
import { default as mixinLXMyPSfahwMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article/mixin.js?macro=true";
import { default as _91id_93im6p1inf5SMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/confirmation/[id].vue?macro=true";
import { default as index7Jls83wlinMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/index.vue?macro=true";
import { default as infos_45facturationovrlulA5ATMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/infos-facturation.vue?macro=true";
import { default as commander_45pronUB1WwHAA0Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro.vue?macro=true";
import { default as _91id_93bavCrXNLdNMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/adresse-livraison/[id].vue?macro=true";
import { default as indexDUbfaH14SVMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/adresse-livraison/index.vue?macro=true";
import { default as deja_45traiteechu59O2RVzMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/deja-traitee.vue?macro=true";
import { default as en_45attenteqDHBpufrI9Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/en-attente.vue?macro=true";
import { default as oksz4tDIFYYiMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/ok.vue?macro=true";
import { default as annulationClJGRiaIzXMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/annulation.vue?macro=true";
import { default as erreur1il0UwZgUjMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/erreur.vue?macro=true";
import { default as refusk73M5r6FRdMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/refus.vue?macro=true";
import { default as indexj8Bkd49EIFMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/connexion/index.vue?macro=true";
import { default as indexUkJlm3x5sWMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/creation-compte/index.vue?macro=true";
import { default as indexH7vFTr3yAiMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/index.vue?macro=true";
import { default as mode_45livraisonX5A5ubH9o0Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/mode-livraison.vue?macro=true";
import { default as paiement_45et_45avantagesw88ySnEU1jMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/paiement-et-avantages.vue?macro=true";
import { default as produits_45incompatiblesJHRMDfCUZGMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/produits-incompatibles.vue?macro=true";
import { default as commanderz8DsgFzspHMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander.vue?macro=true";
import { default as indexEKlPaxmL4oMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/confirmation-creation-compte/index.vue?macro=true";
import { default as indexy8aCCb2KubMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/connexion/index.vue?macro=true";
import { default as indexQsbvToG90pMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/creation-carte-fidelite/index.vue?macro=true";
import { default as index63F7lBYbIKMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/creation-compte/index.vue?macro=true";
import { default as indexU8rUlW5E7qMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/erreur-creation-carte/index.vue?macro=true";
import { default as indexY8ZRnI8WvoMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/index.vue?macro=true";
import { default as _91ean_93W2O4aAtR9YMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infoconso/[ean].vue?macro=true";
import { default as indexn6wMRDptLQMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infoconso/index.vue?macro=true";
import { default as _91_46_46_46slug_93MgzBa3RLEFMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services/[...slug].vue?macro=true";
import { default as indexuEPEf1SdrHMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services/index.vue?macro=true";
import { default as infos_45et_45servicesN9HkdZ9HkyMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services.vue?macro=true";
import { default as _91_46_46_46slug_93MEAhLP3ivUMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/legal/[...slug].vue?macro=true";
import { default as _91articleSlug_93_45a_45_91articleId_93xOjN3s8ANvMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/blog/[articleSlug]-a-[articleId].vue?macro=true";
import { default as index5H8LkGf1woMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/blog/index.vue?macro=true";
import { default as indexgfBNliiOqIMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/index.vue?macro=true";
import { default as indexdswFZkgXiUMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mdp-oublie/index.vue?macro=true";
import { default as indexlLOudp9ZqdMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mes-recettes-personnelles/index.vue?macro=true";
import { default as indexNPqlat9bv1Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mes-repas/index.vue?macro=true";
import { default as indexcwjNT81HtuMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/abonnements/index.vue?macro=true";
import { default as index9VKdsbd8A0Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/index.vue?macro=true";
import { default as indexjjMg6F9IQ4Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/ma-fidelite/index.vue?macro=true";
import { default as index98NT2ppFePMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-adresses/index.vue?macro=true";
import { default as indexsrNTlb9urdMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-cartes-bancaires/index.vue?macro=true";
import { default as indexq3xEdjrXUnMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/[id]/index.vue?macro=true";
import { default as produitsn6FtWepkydMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/[id]/produits.vue?macro=true";
import { default as indexcy2AhR1KIKMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/en-magasin/index.vue?macro=true";
import { default as indexPiq2qbAk90Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/index.vue?macro=true";
import { default as mes_45commandesqEfrdNj0AcMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes.vue?macro=true";
import { default as _91id_93470eb7UXmDMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-listes-de-courses/[id].vue?macro=true";
import { default as indexwZRGqYYVEFMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-listes-de-courses/index.vue?macro=true";
import { default as indexNTbBeieUmcMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-produits-habituels/index.vue?macro=true";
import { default as index8MezchVaDaMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mon-profil/index.vue?macro=true";
import { default as indexuMPw0GejEZMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/toutes-mes-commandes/index.vue?macro=true";
import { default as mon_45compteLZkY1uUI65Meta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte.vue?macro=true";
import { default as indexL46cFaUCzJMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/panier/index.vue?macro=true";
import { default as indexqzo9tbPixzMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/planning/index.vue?macro=true";
import { default as _91_46_46_46slug_93PTRYfG2lNBMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_930cMKYvioOOMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/borne/[...slug].vue?macro=true";
import { default as indexQ2FxeRx2qYMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/borne/index.vue?macro=true";
import { default as indexqP8wn0ESBFMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/index.vue?macro=true";
import { default as indexgEaTK5845VMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/rayons/index.vue?macro=true";
import { default as indexPI0PuYwCfEMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recettes-favorites/index.vue?macro=true";
import { default as indexbqsyJDtgMJMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recettes/index.vue?macro=true";
import { default as _91_46_46_46filtersQuery_93WDdWgEBPbPMeta } from "/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recherche/[...filtersQuery].vue?macro=true";
export default [
  {
    name: "slug-lastSlug-c-id-filtersQuery",
    path: "/:slug(.*)*/:lastSlug()-c-:id()/:filtersQuery(.*)*",
    meta: _91_46_46_46filtersQuery_93LXCQnWF6hfMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/[...slug]/[lastSlug]-c-[id]/[...filtersQuery].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "abonnement-livraison",
    path: "/abonnement-livraison",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/abonnement-livraison/index.vue").then(m => m.default || m)
  },
  {
    name: "accueil-fidelite",
    path: "/accueil-fidelite",
    meta: indexxuoAe3T0EiMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/accueil-fidelite/index.vue").then(m => m.default || m)
  },
  {
    name: "article-ean-ean",
    path: "/article-ean/:ean()",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article-ean/[ean].vue").then(m => m.default || m)
  },
  {
    name: "article-id-slug",
    path: "/article/:id()/:slug?",
    meta: _91_91slug_93_93yEodQVTP24Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article/[id]/[[slug]].vue").then(m => m.default || m)
  },
  {
    name: "article-mixin",
    path: "/article/mixin",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/article/mixin.js").then(m => m.default || m)
  },
  {
    name: commander_45pronUB1WwHAA0Meta?.name,
    path: "/commander-pro",
    meta: commander_45pronUB1WwHAA0Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro.vue").then(m => m.default || m),
    children: [
  {
    name: "commander-pro-confirmation-id",
    path: "confirmation/:id()",
    meta: _91id_93im6p1inf5SMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/confirmation/[id].vue").then(m => m.default || m)
  },
  {
    name: "commander-pro",
    path: "",
    meta: index7Jls83wlinMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/index.vue").then(m => m.default || m)
  },
  {
    name: "commander-pro-infos-facturation",
    path: "infos-facturation",
    meta: infos_45facturationovrlulA5ATMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander-pro/infos-facturation.vue").then(m => m.default || m)
  }
]
  },
  {
    name: commanderz8DsgFzspHMeta?.name,
    path: "/commander",
    meta: commanderz8DsgFzspHMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander.vue").then(m => m.default || m),
    children: [
  {
    name: "commander-adresse-livraison-id",
    path: "adresse-livraison/:id()",
    meta: _91id_93bavCrXNLdNMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/adresse-livraison/[id].vue").then(m => m.default || m)
  },
  {
    name: "commander-adresse-livraison",
    path: "adresse-livraison",
    meta: indexDUbfaH14SVMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/adresse-livraison/index.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-id-deja-traitee",
    path: "confirmation/:id()/deja-traitee",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/deja-traitee.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-id-en-attente",
    path: "confirmation/:id()/en-attente",
    meta: en_45attenteqDHBpufrI9Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/en-attente.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-id-ok",
    path: "confirmation/:id()/ok",
    meta: oksz4tDIFYYiMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/[id]/ok.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-annulation",
    path: "confirmation/annulation",
    meta: annulationClJGRiaIzXMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/annulation.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-erreur",
    path: "confirmation/erreur",
    meta: erreur1il0UwZgUjMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/erreur.vue").then(m => m.default || m)
  },
  {
    name: "commander-confirmation-refus",
    path: "confirmation/refus",
    meta: refusk73M5r6FRdMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/confirmation/refus.vue").then(m => m.default || m)
  },
  {
    name: "commander-connexion",
    path: "connexion",
    meta: indexj8Bkd49EIFMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/connexion/index.vue").then(m => m.default || m)
  },
  {
    name: "commander-creation-compte",
    path: "creation-compte",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/creation-compte/index.vue").then(m => m.default || m)
  },
  {
    name: "commander",
    path: "",
    meta: indexH7vFTr3yAiMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/index.vue").then(m => m.default || m)
  },
  {
    name: "commander-mode-livraison",
    path: "mode-livraison",
    meta: mode_45livraisonX5A5ubH9o0Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/mode-livraison.vue").then(m => m.default || m)
  },
  {
    name: "commander-paiement-et-avantages",
    path: "paiement-et-avantages",
    meta: paiement_45et_45avantagesw88ySnEU1jMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/paiement-et-avantages.vue").then(m => m.default || m)
  },
  {
    name: "commander-produits-incompatibles",
    path: "produits-incompatibles",
    meta: produits_45incompatiblesJHRMDfCUZGMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/commander/produits-incompatibles.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "confirmation-creation-compte",
    path: "/confirmation-creation-compte",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/confirmation-creation-compte/index.vue").then(m => m.default || m)
  },
  {
    name: "connexion",
    path: "/connexion",
    meta: indexy8aCCb2KubMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/connexion/index.vue").then(m => m.default || m)
  },
  {
    name: "creation-carte-fidelite",
    path: "/creation-carte-fidelite",
    meta: indexQsbvToG90pMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/creation-carte-fidelite/index.vue").then(m => m.default || m)
  },
  {
    name: "creation-compte",
    path: "/creation-compte",
    meta: index63F7lBYbIKMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/creation-compte/index.vue").then(m => m.default || m)
  },
  {
    name: "erreur-creation-carte",
    path: "/erreur-creation-carte",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/erreur-creation-carte/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexY8ZRnI8WvoMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "infoconso-ean",
    path: "/infoconso/:ean()",
    meta: _91ean_93W2O4aAtR9YMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infoconso/[ean].vue").then(m => m.default || m)
  },
  {
    name: "infoconso",
    path: "/infoconso",
    meta: indexn6wMRDptLQMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infoconso/index.vue").then(m => m.default || m)
  },
  {
    name: infos_45et_45servicesN9HkdZ9HkyMeta?.name,
    path: "/infos-et-services",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services.vue").then(m => m.default || m),
    children: [
  {
    name: "infos-et-services-slug",
    path: ":slug(.*)*",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "infos-et-services",
    path: "",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/infos-et-services/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "legal-slug",
    path: "/legal/:slug(.*)*",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/legal/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "magasins-slug-m-id-blog-articleSlug-a-articleId",
    path: "/magasins/:slug()-m-:id()/blog/:articleSlug()-a-:articleId()",
    meta: _91articleSlug_93_45a_45_91articleId_93xOjN3s8ANvMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/blog/[articleSlug]-a-[articleId].vue").then(m => m.default || m)
  },
  {
    name: "magasins-slug-m-id-blog",
    path: "/magasins/:slug()-m-:id()/blog",
    meta: index5H8LkGf1woMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "magasins-slug-m-id",
    path: "/magasins/:slug()-m-:id()",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/magasins/[slug]-m-[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "mdp-oublie",
    path: "/mdp-oublie",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mdp-oublie/index.vue").then(m => m.default || m)
  },
  {
    name: "mes-recettes-personnelles",
    path: "/mes-recettes-personnelles",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mes-recettes-personnelles/index.vue").then(m => m.default || m)
  },
  {
    name: "mes-repas",
    path: "/mes-repas",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mes-repas/index.vue").then(m => m.default || m)
  },
  {
    name: mon_45compteLZkY1uUI65Meta?.name,
    path: "/mon-compte",
    meta: mon_45compteLZkY1uUI65Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte.vue").then(m => m.default || m),
    children: [
  {
    name: "mon-compte-abonnements",
    path: "abonnements",
    meta: indexcwjNT81HtuMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/abonnements/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte",
    path: "",
    meta: index9VKdsbd8A0Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-ma-fidelite",
    path: "ma-fidelite",
    meta: indexjjMg6F9IQ4Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/ma-fidelite/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-adresses",
    path: "mes-adresses",
    meta: index98NT2ppFePMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-adresses/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-cartes-bancaires",
    path: "mes-cartes-bancaires",
    meta: indexsrNTlb9urdMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-cartes-bancaires/index.vue").then(m => m.default || m)
  },
  {
    name: mes_45commandesqEfrdNj0AcMeta?.name,
    path: "mes-commandes",
    meta: mes_45commandesqEfrdNj0AcMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes.vue").then(m => m.default || m),
    children: [
  {
    name: "mon-compte-mes-commandes-id",
    path: ":id()",
    meta: indexq3xEdjrXUnMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-commandes-id-produits",
    path: ":id()/produits",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/[id]/produits.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-commandes-en-magasin",
    path: "en-magasin",
    meta: indexcy2AhR1KIKMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/en-magasin/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-commandes",
    path: "",
    meta: indexPiq2qbAk90Meta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-commandes/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "mon-compte-mes-listes-de-courses-id",
    path: "mes-listes-de-courses/:id()",
    meta: _91id_93470eb7UXmDMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-listes-de-courses/[id].vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-listes-de-courses",
    path: "mes-listes-de-courses",
    meta: indexwZRGqYYVEFMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-listes-de-courses/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mes-produits-habituels",
    path: "mes-produits-habituels",
    meta: indexNTbBeieUmcMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mes-produits-habituels/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-mon-profil",
    path: "mon-profil",
    meta: index8MezchVaDaMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/mon-profil/index.vue").then(m => m.default || m)
  },
  {
    name: "mon-compte-toutes-mes-commandes",
    path: "toutes-mes-commandes",
    meta: indexuMPw0GejEZMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/mon-compte/toutes-mes-commandes/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "panier",
    path: "/panier",
    meta: indexL46cFaUCzJMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/panier/index.vue").then(m => m.default || m)
  },
  {
    name: "planning",
    path: "/planning",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/planning/index.vue").then(m => m.default || m)
  },
  {
    name: "prospectus-slug",
    path: "/prospectus/:slug(.*)*",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "prospectus-borne-slug",
    path: "/prospectus/borne/:slug(.*)*",
    meta: _91_46_46_46slug_930cMKYvioOOMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/borne/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "prospectus-borne",
    path: "/prospectus/borne",
    meta: indexQ2FxeRx2qYMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/borne/index.vue").then(m => m.default || m)
  },
  {
    name: "prospectus",
    path: "/prospectus",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/prospectus/index.vue").then(m => m.default || m)
  },
  {
    name: "rayons",
    path: "/rayons",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/rayons/index.vue").then(m => m.default || m)
  },
  {
    name: "recettes-favorites",
    path: "/recettes-favorites",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recettes-favorites/index.vue").then(m => m.default || m)
  },
  {
    name: "recettes",
    path: "/recettes",
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recettes/index.vue").then(m => m.default || m)
  },
  {
    name: "recherche-filtersQuery",
    path: "/recherche/:filtersQuery(.*)*",
    meta: _91_46_46_46filtersQuery_93WDdWgEBPbPMeta || {},
    component: () => import("/home/ec2-user/workspace/builds/ecom-corafr-fo-nuxt3/ecom-corafr-fo production@2/pages/recherche/[...filtersQuery].vue").then(m => m.default || m)
  }
]